module.exports = __webpack_public_path__ + "static/img/mneMainImgOne.4473738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mneMainImgOne.png
// module id = wLW5
// module chunks = 1